import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFormattedNumber } from "@msys/formatting";
import { KeyboardArrowDown as KeyboardArrowDown } from "@mui/icons-material";
import { Autocomplete, autocompleteClasses, Box, Button, Checkbox, FilledInput, filledInputClasses, Stack, Typography, } from "@mui/material";
import { identity } from "lodash-es";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
import { PopoverOpenButton, } from "../popover/PopoverOpenButton.js";
import { defaultFilterOptions, PopperComponent } from "./ButtonSelect.js";
export const ButtonSelectMultiple = (props) => {
    const [open, setOpen] = React.useState(false);
    const popoverOpenButtonRef = React.useRef();
    return (_jsx(PopoverOpenButton, { onOpen: () => setOpen(true), onClose: () => setOpen(false), content: _jsx(ButtonSelectMultipleForm, { ...props, handleClose: () => popoverOpenButtonRef.current?.handleClose() }), anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "left",
        }, popoverRef: popoverOpenButtonRef, children: _jsxs(Button, { size: "extra-small", variant: "text", color: "primary", sx: { textTransform: "none" }, endIcon: _jsx(KeyboardArrowDown, { sx: {
                    transition: "transform 0.2s ease-out",
                    ...(open ? { transform: `rotate(-180deg)` } : undefined),
                } }), disabled: props.disabled, children: [props.label, props.value.length > 0 ? ` (${props.value.length})` : ""] }) }));
};
function ButtonSelectMultipleForm({ searchLabel, noOptionsLabel, options, value, onChange, filterOptions = defaultFilterOptions, handleClose, popoverWidth = "md", }) {
    const locale = useLocale();
    const [inputValue, setInputValue] = React.useState("");
    const _options = filterOptions(options, { inputValue });
    return (_jsx(Stack, { sx: theme => ({
            width: `${theme.layout.filters.popoverWidth[popoverWidth]}px`,
        }), spacing: 0, direction: "column", children: _jsx(Autocomplete, { open: true, multiple: true, fullWidth: true, disableCloseOnSelect: true, size: "extra-small", onClose: (event, reason) => {
                if (reason === "escape") {
                    handleClose();
                }
            }, inputValue: inputValue, onInputChange: (_, value, reason) => {
                if (reason === "input") {
                    setInputValue(value);
                }
            }, value: _options.filter(o => value.includes(o.value)), onChange: (event, newValue, reason) => {
                if (event.type === "keydown" &&
                    (event.key === "Backspace" ||
                        event.key === "Delete") &&
                    reason === "removeOption") {
                    return;
                }
                onChange(newValue.map(v => v.value));
            }, filterOptions: identity, noOptionsText: noOptionsLabel, renderOption: (props, option, { selected }) => (_createElement("li", { ...props, key: typeof option.value === "string"
                    ? option.value
                    : JSON.stringify(option.value) }, option.icon || option.value || option.counter !== undefined ? (_jsxs(Stack, { alignItems: "center", direction: "row", spacing: 1, flex: 1, children: [_jsx(Box, { display: "flex", alignItems: "center", height: 0, children: _jsx(Checkbox, { edge: "start", size: "small", checked: value.includes(option.value), tabIndex: -1, disableRipple: true }) }), option.icon, _jsx(Typography, { variant: "body2", sx: { flex: 1 }, children: option.label }), option.counter !== undefined ? (_jsx(Typography, { variant: "caption", sx: { color: "grey.600" }, children: getFormattedNumber(option.counter, locale) })) : null] })) : (_jsx(Typography, { variant: "body2", children: option.label })))), options: _options, getOptionLabel: option => option.label, renderInput: params => (_jsx(FilledInput, { size: "extra-small", type: "search", fullWidth: true, ref: params.InputProps.ref, inputProps: { enterKeyHint: "search", ...params.inputProps }, autoFocus: true, placeholder: `${searchLabel}…`, sx: {
                    [`&.${filledInputClasses.root}`]: {
                        padding: "0 !important",
                    },
                } })), sx: theme => ({
                [`&.${autocompleteClasses.root}`]: {
                    paddingX: 1,
                    width: "100%",
                    ...(options.length < 10
                        ? { height: 0, overflow: "hidden" }
                        : {
                            paddingY: 1,
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        }),
                },
            }), slots: {
                popper: PopperComponent,
            } }) }));
}
//# sourceMappingURL=ButtonSelectMultiple.js.map